import { ElementType } from 'react';
import styled from '@emotion/styled';
import { Colors } from '../../Colors';
import { css, SerializedStyles } from '@emotion/react';
import { helperButtonReset, helperLinkReset } from '../../../helpers';

const propView = ['default', 'blue', 'gray', 'dim', 'primary'] as const;
type PropView = typeof propView[number];

export interface LinkProps {
  as?: ElementType;
  to?: string;
  onClick?: (e: React.SyntheticEvent) => void;
  weight?: 'regular' | 'bold';
  view?: PropView;
}

const defaultView = css`
  color: ${Colors.text.default};
  -webkit-tap-highlight-color: ${Colors.ut.primaryDim};
  text-decoration: underline;
  text-decoration-color: ${Colors.text.defaultDim};

  &:hover,
  &:focus-visible {
    color: ${Colors.text.defaultDim};
  }
`;

const primaryView = css`
  color: ${Colors.text.primary};
  -webkit-tap-highlight-color: ${Colors.ut.primaryDim};

  &:hover,
  &:focus-visible {
    color: ${Colors.text.primaryInverse};
  }
`;

const dimView = css`
  color: ${Colors.text.defaultDim};
  text-decoration: underline;
  -webkit-tap-highlight-color: ${Colors.ut.inputDown};

  &:hover,
  &:focus-visible {
    color: ${Colors.text.default};
  }
`;

const view: { [key in PropView]: SerializedStyles } = {
  default: defaultView,
  primary: primaryView,
  dim: dimView,

  /**
   * @deprecated старое название, используй вместо него primary
   */
  blue: primaryView,

  /**
   * @deprecated старое название, используй вместо него dim
   */
  gray: dimView
};

const LinkText = styled('a')<LinkProps>`
  ${helperLinkReset};
  font-weight: ${props => props.weight === 'bold' && '700'};

  ${props => props.as === 'button' && helperButtonReset};
  ${props => view[props.view ?? 'blue']};
`;

export default LinkText;
export { propView as typographyLinkTextPropView };
export type { PropView as TypographyLinkTextPropView };
